/* SEKO : fiche produit, bouton de commande toujours a portee de pouce.
   Quand le vrai bouton "Ajouter au panier et commander" sort de l'ecran, une barre noire fixe apparait en bas : c'est le bouton lui-meme, sur toute la largeur.
   Elle ne fait qu'appuyer sur le vrai bouton a la place de la cliente : le fonctionnement de la commande ne change pas. */
(function () {
  var titre = document.querySelector('[data-seko-produit]');
  if (!titre) return;
  var racine = titre.closest('.shopify-section') || document;
  var LIBELLE = 'Ajouter au panier et commander';
  var barre = null;
  var vraiVisible = true;

  function trouver() {
    var els = racine.querySelectorAll('button, [role="button"], a, div, span');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest('.seko-barre')) continue;
      if (el.children.length === 0 && (el.textContent || '').trim().indexOf(LIBELLE) === 0) {
        return el.closest('button, [role="button"], a') || el;
      }
    }
    return racine.querySelector('[class*="_rsi"][class*="button"], [id*="_rsi"][id*="button"]');
  }

  function styles() {
    if (document.getElementById('seko-barre-css')) return;
    var s = document.createElement('style');
    s.id = 'seko-barre-css';
    /* z-index tres eleve : la barre passe devant la bulle WhatsApp tant qu'elle est visible. Elle s'efface des que le formulaire s'ouvre. */
    s.textContent = '.seko-barre{position:fixed;left:0;right:0;bottom:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;width:100%;min-height:58px;margin:0;border:0;border-radius:0;background:#252524;color:#FFFFFF;font-size:16px;font-weight:600;font-family:inherit;line-height:1.2;cursor:pointer;padding:0 16px env(safe-area-inset-bottom,0px);box-sizing:content-box;transform:translateY(110%);transition:transform .25s ease;-webkit-tap-highlight-color:transparent}' +
      '.seko-barre.est-visible{transform:none}' +
      '.seko-barre:focus-visible{outline:2px solid #CDA98B;outline-offset:-4px}' +
      '@media (min-width:900px){.seko-barre{display:none !important}}' +
      '@media (prefers-reduced-motion:reduce){.seko-barre{transition:none}}';
    document.head.appendChild(s);
  }

  function popupOuvert() {
    var l = document.querySelector('.seko-continue');
    return !!(l && l.offsetParent !== null);
  }

  function afficher() {
    if (!barre) return;
    var oui = !vraiVisible && !popupOuvert() && !document.querySelector('.seko-oups');
    barre.classList.toggle('est-visible', oui);
  }

  function construire(vrai) {
    styles();
    barre = document.createElement('button');
    barre.type = 'button';
    barre.className = 'seko-barre';
    barre.textContent = LIBELLE;
    barre.addEventListener('click', function () {
      barre.classList.remove('est-visible');
      var v = trouver();
      if (v) { v.click(); }
    });
    document.body.appendChild(barre);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        vraiVisible = entrees[0].isIntersecting;
        afficher();
      }, { threshold: 0.1 }).observe(vrai);
    }
  }

  /* Le bouton de l'application arrive un peu apres le chargement de la page : on l'attend. */
  var essais = 0;
  var attente = setInterval(function () {
    essais++;
    var v = trouver();
    if (v) { clearInterval(attente); construire(v); }
    else if (essais > 40) { clearInterval(attente); }
  }, 400);

  document.addEventListener('click', function () { setTimeout(afficher, 350); }, true);
  window.addEventListener('scroll', function () { afficher(); }, { passive: true });
})();
